<template>
  <v-app>
    <router-view name="AdminAppBar"/>
    <router-view v-if="tg === ''" name="AppBar"/>
    <v-main>
      <router-view name="Admin"/>
      <v-container class="pa-0">
      <router-view name="Tab"/>
    <v-row justify="center" class="ma-0">
    <v-col  class="pa-0">
      <router-view/>
    </v-col>
    </v-row>
    </v-container>
    </v-main>

    <FooterComponent></FooterComponent >
    <Snackbar></Snackbar>


  </v-app>

  <DialogNotAuth></DialogNotAuth>
  <DialogNotSelectServer></DialogNotSelectServer>

</template>

<script setup>
import { useUserStore } from './stores/userStore';
import { ref, onMounted, watch, defineAsyncComponent } from 'vue';
import { useTheme } from 'vuetify';
import { useRouter } from 'vue-router'
import { useAblyStore } from '@/stores/ablyStore';
import { useChatStore } from '@/stores/chatStore';

const Snackbar = defineAsyncComponent(() => import('./components/utilit/Snackbar.vue'))
const FooterComponent = defineAsyncComponent(() => import('./components/layouts/FooterComponent.vue'))
const DialogNotAuth = defineAsyncComponent(() => import('./components/utilit/dialog/DialogNotAuth.vue'))
const DialogNotSelectServer = defineAsyncComponent(() => import('./components/utilit/dialog/DialogNotSelectServer.vue'))
const ablyStore = useAblyStore();
const messages = ref([]);
const error = ref(null);
const loading = ref(false);


const handleMessage = (message) => {
  console.log('Handling message:', message);
  messages.value.push(message.data.message);
  // Чат-сообщения
  if (message.data?.message?.type === 'chat_message') {
    useChatStore().addMessage(message.data.message);
  }
};
const router = useRouter()
const tg = ref(window?.Telegram?.WebApp?.initData)
const theme = useTheme()
const user = useUserStore().user
if (tg.value === '') {

  //if (user.access_token) {
   //const data = useUserStore().auth()
   // if (data.Unauthenticated) {
   //   localStorage.removeItem('access_token')
   // }
  //}
  if (localStorage.getItem('theme')) {
  theme.global.name.value = localStorage.getItem('theme')
} else {
  let os_theme = window ?. matchMedia ?. ('(prefers-color-scheme:dark)') ?. matches ?? false
  os_theme == true ? theme.global.name.value = 'dark' : theme.global.name.value = 'light'
}

}

if (window?.Telegram?.WebApp?.initData) {
 // obj.value =   {
    //  initData:window.Telegram.WebApp.initData,
    //  initDataUnsafe:window.Telegram.WebApp.initDataUnsafe
   // }
  //if (user.access_token) {
   //const data = useUserStore().auth()
   // if (data.Unauthenticated) {
    //  useUserStore().web_app(obj.value)
   // }
  //}
  //else  useUserStore().web_app(obj.value)
  theme.global.name.value = window.Telegram.WebApp.colorScheme

  }

  const subscribeToUserChannel = async () => {
      if (!user.id) return; // Если userId отсутствует, выходим

      try {
        loading.value = true;

        // Подключаемся к Ably
        await ablyStore.connectToAbly();

        // Подписываемся на канал пользователя
        ablyStore.subscribeToChannel('private:user.' + user.id, handleMessage);

        error.value = null;
      } catch (err) {
        error.value = 'Failed to connect to Ably';
        console.error('Error connecting to Ably:', err);
      } finally {
        loading.value = false;
      }
    };

  onMounted(async () => {
if (window?.Telegram?.WebApp?.initData) {
  window.Telegram.WebApp.onEvent('backButtonClicked', handleBackButtonClick)
  //window.Telegram.WebApp.disableVerticalSwipes()

}

})

watch(
      () => user.id,
      (newUserId) => {
        if (newUserId) {
          subscribeToUserChannel(); // Подписываемся на канал, когда userId доступен
        }
      },
      { immediate: true } // Выполнить сразу при создании компонента
    );


const handleBackButtonClick = () => {
  // Обработка события нажатия на кнопку "mainButton"
  console.log('Нажата кнопка BackButton')
  try {
    router.go(-1)
  } catch (error) {
    console.error('Ошибка навигации:', error)
    // Если есть ошибка, переходим на главную страницу
    router.push('/')
  }
}







</script>


<style>
html {
  scrollbar-width: none;
}
td {
      width: 5em;
      line-height: 2em;
      cursor: pointer;

  }
  tr:hover {

      background-color: #f6f5f5;
      color:black;
  }

  tr:hover td {
      background-color: transparent;
      color:black;
  }

</style>
